import React from 'react';
import WOW from 'wowjs';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import translate from '../translate';
import {Link} from 'react-router-dom';

function Hero() {
    const language = useSelector(state => state.view.selectedLanguage);
    const componentName = 'hero';

    useEffect(() => {
        const wow = new WOW.WOW({
            live: false,
            offset: 100,
            mobile: true,
        });
        wow.init();
    }, []);

    return (
        <section className="hero-section pt-60">
        <div className="shape shape__1 position-absolute wow fadeInUp" data-wow-delay="300ms" data-wow-duration="800ms"><img src="assets/img/shapes/hero-shape-1.png" alt=""/></div>
        <div className="shape shape__2 position-absolute wow fadeInUp" data-wow-delay="600ms" data-wow-duration="800ms"><img src="assets/img/shapes/hero-shape-2.png" alt=""/></div>
        <div className="container">
            <div className="row flex-lg-row flex-md-column-reverse">
                <div className="col-xl-5 col-lg-5">
                    <div className="inner-content">
                        <h1 className="title wow fadeInUp" data-wow-delay="200ms" data-wow-duration="800ms">{translate(componentName, 'title', language)}</h1>
                        <p className="hero-text">{translate(componentName, 'description', language)}</p>
                        <div className="inner-btns mt-50">
                            <Link to="/services" className="btn wow fadeInUp" data-wow-delay="500ms" data-wow-duration="800ms">{translate(componentName, 'ourService', language)} <span></span></Link>
                        </div>
                        <div className="social-links mt-140">
                            <a href="#0" className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="800ms" target="_blank"><i className="fab fa-facebook-f"></i> <span>{translate(componentName, 'facebook', language)}</span></a>
                            <a href="#0" className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="800ms" target="_blank"><i className="fab fa-youtube"></i> <span>{translate(componentName, 'youtube', language)}</span></a>
                            <a href="#0" className="wow fadeInUp" data-wow-delay="600ms" data-wow-duration="800ms" target="_blank"><i className="fab fa-twitter"></i> <span>{translate(componentName, 'twitter', language)}</span></a>
                            <a href="#0" className="wow fadeInUp" data-wow-delay="800ms" data-wow-duration="800ms" target="_blank"><i className="fab fa-linkedin"></i> <span>{translate(componentName, 'linkedin', language)}</span></a>
                        </div>
                    </div>
                </div>
                <div className="col-xl-7 col-lg-7">
                    <div className="inner-right">
                        <div className="img-wrapper wow zoomIn" data-wow-delay="700ms" data-wow-duration="800ms">
                            <img src="./assets/img/hero/developer.png" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    );
}

export default Hero;